'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Renders a component into the DOM,
 * given a specific destination div
 * and a store.
 *
 * If no dev tools are present, will
 * wrap the component in a surrounding div
 * to mimic the appearance of the dev tools.
 */
exports.default = function (component, store, destination) {
  if (!window.devToolsExtension) {
    return _reactDom2.default.render(_react2.default.createElement(
      _reactRedux.Provider,
      {
        store: store
      },
      _react2.default.createElement(
        'div',
        null,
        component
      )
    ), destination);
  }

  return _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    {
      store: store
    },
    component
  ), destination);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/browser/renderIntoDOM.jsx
// module id = 1066
// module chunks = 0